function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import React from "react";
import shortid from "shortid";

/**
 * This HOC injects unique ids into the lower order component (LOC)
 *
 * 1. It makes sure to generate the unique ids ONCE during creation of the component
 * 2. It allows ids to be passed in as props, which take precedence
 * 3. If the prop provided id changes, the change is passed down to the LOC
 */
var uniqueID = function uniqueID(propNames) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$generate = _ref.generate,
    generate = _ref$generate === void 0 ? shortid.generate : _ref$generate;
  var generateKeysReducer = function generateKeysReducer(obj, key) {
    return _objectSpread(_defineProperty({}, key, generate()), obj);
  };
  return function (LowerOrderComponent) {
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      var fallbackIds = React.useRef(_reduceInstanceProperty(propNames).call(propNames, generateKeysReducer, {}));
      return /*#__PURE__*/React.createElement(LowerOrderComponent, _extends({
        ref: ref
      }, fallbackIds.current, props));
    });
  };
};
export default uniqueID;
export var useUniqueID = function useUniqueID(override) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$generate = _ref2.generate,
    generate = _ref2$generate === void 0 ? shortid.generate : _ref2$generate;
  var _React$useRef = React.useRef(typeof override !== 'undefined'),
    isControlled = _React$useRef.current;
  var idRef = React.useRef();
  if (isControlled) {
    return override;
  }
  if (!idRef.current) {
    idRef.current = generate();
  }
  return idRef.current;
};